export function toast(message, color, duration = 2000) {
    const toast = document.createElement('ion-toast');
    toast.message = message;
    toast.duration = duration;
    toast.color = color;
    // toast.translucent = true;
    toast.mode = 'ios';
    document.body.appendChild(toast);
    return toast.present();
  }